import React, { Component } from "react"
import { graphql } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { Spring, animated } from "react-spring/renderprops"

import Layout from "../components/layout"
import SEO from "../components/seo"
import FooterMenu from "../components/footer-menu/footer-menu"
import Play from "../components/play/play"
import Button from "../components/button/button"
import $ from "jquery"
import "lightgallery"
import "lg-video"
import "lg-zoom"

import img_1 from "../images/bathroom.jpg"
import img_2 from "../images/bathroom2.jpg"
import img_3 from "../images/kitchen.jpg"
import img_4 from "../images/kitchen2.jpg"
import img_5 from "../images/kitchen3.jpg"
import img_6 from "../images/closet.jpg"
import img_7 from "../images/den1.jpg"
import img_8 from "../images/living.jpg"
import img_9 from "../images/terrace.jpg"
import img_10 from "../images/outdoor.jpg"
import img_11 from "../images/outdoor2.jpg"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./interiors.sass"

const LANDING =
  "https://player.vimeo.com/external/345988715.hd.mp4?s=2d27c3c073d0936f6a2339585f9411e067c22861&profile_id=175"

class Interiors extends Component {
  onLightGallery = node => {
    this.lightGallery = node
    $(node).lightGallery()
  }

  componentWillUnmount() {
    $(this.lightGallery)
      .data("lightGallery")
      .destroy(true)
  }

  render() {
    return (
      <Layout>
        <SEO title="Interiors" />
        <div id="interiors">
          <div className="page-hero-section">
            <div className="full-screen-vid-wrapper" ref={this.onLightGallery}>
              <a href="https://youtu.be/aof_45je8Tg">
                <div className="grid-line line-1"></div>
                <div className="grid-line line-2"></div>
                <video
                  src={LANDING}
                  data-keepplaying
                  autoPlay
                  muted
                  loop
                  playsInline
                />
                <div className="vid-overlay"></div>
                <Play />
              </a>
            </div>
            <div className="page-hero-content-wrapper">
              <Spring
                from={{ opacity: 0, transform: "translate3d(-60px, 0, 0)" }}
                to={{ opacity: 1, transform: "translate3d(0, 0, 0)" }}
                config={{
                  delay: 300,
                }}
              >
                {props => (
                  <animated.div style={props} className="hero-content">
                    <h1 className="page-title">The Art of Luxury Living</h1>
                    <p className="desc">
                      From stonework to millwork, and fixtures to appliances, we
                      have selected only the finest materials available for The
                      Concord. The collection of top-of-the-line materials and
                      impressive brand names is part of our development process
                      that creates outstanding homes with truly lasting value.
                    </p>
                  </animated.div>
                )}
              </Spring>
              <Spring
                from={{ opacity: 0, transform: "translate3d(60px, 0, 0)" }}
                to={{ opacity: 1, transform: "translate3d(0, 0, 0)" }}
                config={{
                  delay: 300,
                }}
              >
                {props => (
                  <animated.div style={props} className="scroll-wrapper">
                    <h5>Scroll down to discover</h5>
                  </animated.div>
                )}
              </Spring>
            </div>
          </div>
          <div className="interior-section-2">
            <div className="grid-fluid">
              <div className="col-2">
                <div className="img-collection" ref={this.onLightGallery}>
                  <BackgroundImage
                    Tag="section"
                    className="interior-image bathroom"
                    fluid={this.props.data.bathroom.childImageSharp.fluid}
                    href={img_1}
                  >
                    <div className="overlay" />
                    <div className="paging">
                      <FontAwesomeIcon
                        icon={["fal", "clone"]}
                        className="font-awesome-icon"
                      />
                      <span>2</span>
                    </div>
                  </BackgroundImage>
                  <div className="bg-content-wrapper" href={img_2}>
                    <h1 className="title">Be at the spa, at home</h1>
                    <p className="desc">
                      Pampering is a delight in the spa-like environment of a
                      bathroom at The Concord. Elegant marble floors and wall
                      equipped with in-floor heating system for those cold
                      winter months.
                    </p>
                    <Button cssClass="btn btn-secondary">view images</Button>
                  </div>
                </div>
              </div>
              <div className="col-2">
                <div className="img-collection" ref={this.onLightGallery}>
                  <BackgroundImage
                    Tag="section"
                    className="interior-image kitchen"
                    fluid={this.props.data.kitchen.childImageSharp.fluid}
                    href={img_3}
                  >
                    <div className="overlay" />
                    <div className="paging">
                      <FontAwesomeIcon
                        icon={["fal", "clone"]}
                        className="font-awesome-icon"
                      />
                      <span>3</span>
                    </div>
                  </BackgroundImage>
                  <div href={img_4} />
                  <div className="bg-content-wrapper" href={img_5}>
                    <h1 className="title">Purposeful Kitchen Design</h1>
                    <p className="desc">
                      Pampering is a delight in the spa-like environment of a
                      bathroom at The Concord. Elegant marble floors and wall
                      equipped with in-floor heating system for those cold
                      winter months.
                    </p>
                    <Button cssClass="btn btn-secondary">view images</Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid-fluid">
              <div className="col-2">
                <div className="img-collection" ref={this.onLightGallery}>
                  <BackgroundImage
                    Tag="section"
                    className="interior-image closet"
                    fluid={this.props.data.closet.childImageSharp.fluid}
                    href={img_6}
                  >
                    <div className="overlay" />
                    <div className="paging">
                      <FontAwesomeIcon
                        icon={["fal", "clone"]}
                        className="font-awesome-icon"
                      />
                      <span>3</span>
                    </div>
                  </BackgroundImage>
                  <div href={img_7} />
                  <div className="bg-content-wrapper" href={img_8}>
                    <h1 className="title">Relax and Rejuvenate</h1>
                    <p className="desc">
                      At the Concord, the bedroom is conceived of as an oasis.
                      Spacious walk-in closets with efficient shelfing and smart
                      organizers keep belongings accessible and well presented.
                      Poliform closets for the Master Suite elevate the
                      experience to an even high level.
                    </p>
                    <Button cssClass="btn btn-secondary">view images</Button>
                  </div>
                </div>
              </div>
              <div className="col-2">
                <div className="img-collection" ref={this.onLightGallery}>
                  <BackgroundImage
                    Tag="section"
                    className="interior-image terrace"
                    fluid={this.props.data.terrace.childImageSharp.fluid}
                    href={img_9}
                  >
                    <div className="overlay" />
                    <div className="paging">
                      <FontAwesomeIcon
                        icon={["fal", "clone"]}
                        className="font-awesome-icon"
                      />
                      <span>3</span>
                    </div>
                  </BackgroundImage>
                  <div href={img_10} />
                  <div className="bg-content-wrapper" href={img_11}>
                    <h1 className="title">Al Fresco Living</h1>
                    <p className="desc">
                      From the cleverly-angled balconies to the expansive,
                      outdoor terraces, each home at The Concord is designed to
                      allow you to embrace the freshness of its park-front
                      environment while enjoying your morning coffee, or indulge
                      in the mesmerizing Bow River sunset when hosting a
                      barbeque.
                    </p>
                    <Button cssClass="btn btn-secondary">view images</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-padding" />
        <FooterMenu />
      </Layout>
    )
  }
}

export default Interiors

export const interiorQuery = graphql`
  query {
    bathroom: file(relativePath: { eq: "bathroom.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    kitchen: file(relativePath: { eq: "kitchen.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    closet: file(relativePath: { eq: "closet.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    terrace: file(relativePath: { eq: "terrace.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
